import getApiUrl from './apiUrl';
import imgBaseUrl from './imgBaseUrl';
import branches from './branches';

export const TAX = 6;
export const API_URL = getApiUrl();
export const IMG_BASE_URL = imgBaseUrl();
export { branches };
